import {tryCall} from '@esgi/ui-kit/utils';
import {AnimationState, ClassNamesProp, DurationProp} from './types';

export function getDurationFor(targetEvent: AnimationState, props: DurationProp): number {
	if (typeof props === 'number') {
		return props;
	}
	if (typeof props === 'function') {
		return tryCall(props, targetEvent) || 0;
	}
	return props[targetEvent] || 0;
}

export function getClassNameFor(targetEvent: AnimationState, props: ClassNamesProp): string {
	if (typeof props === 'function') {
		return props(targetEvent);
	}
	return props[targetEvent] || '';
}
